import styled from 'styled-components';
import Filters from 'components/ProductSidebar/menus/Filters';
import Divider from 'ui/Divider/Divider';

const Container = styled.div`
  & div {
    padding: 0;
  }

  & h3 > [data-element-name='kompis-text'] {
    font-size: 1rem;
  }
`;

const ChangeFrameTypeFilter = () => {
  return (
    <Container>
      <Filters isFilterVisible={true} />
      <Divider />
    </Container>
  );
};

export default ChangeFrameTypeFilter;
